import { z } from "zod";

/**
 * 絞り込み条件は URL に持たせる。
 * リンクを渡せば同じ画面が再現でき、ビューの共有が「URL のコピー」で済む（原則 7）。
 */
export const alertsSearchSchema = z.object({
  q: z.string().trim().max(100).catch("").default(""),
  severity: z.enum(["all", "critical", "warning", "info"]).catch("all").default("all"),
  state: z.enum(["all", "open", "acknowledged"]).catch("all").default("all")
});

export const scenariosSearchSchema = z.object({
  q: z.string().trim().max(100).catch("").default(""),
  state: z.enum(["all", "running", "degraded", "paused", "draft"]).catch("all").default("all"),
  category: z.enum(["all", "顧客起点", "商品起点", "AIO", "AIOps"]).catch("all").default("all"),
  page: z.coerce.number().int().min(1).catch(1).default(1),
  pageSize: z.coerce.number().int().min(25).max(100).catch(25).default(25)
});

export type AlertsSearch = z.infer<typeof alertsSearchSchema>;
export type ScenariosSearch = z.infer<typeof scenariosSearchSchema>;
